import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import { Button, InputField, MyModal } from 'src/components/ui'
import { useTranslation } from 'react-i18next'
import { useApproveRequestEmailMutation } from 'src/redux/api'
import { SuccessModal } from 'src/components/elements/modals'

export const ApproveRequestEmail = ({
  open,
  handleClose,
}: {
  open: boolean
  handleClose: () => void
}) => {
  const { t } = useTranslation()
  const { handleSubmit, control } = useForm({ defaultValues: { email: '' } })
  const onSubmit: SubmitHandler<{ email: string }> = (data) => {
    approveRequestEmail({ email: data.email })
      .unwrap()
      .then(() => {
        // handleClose()
      })
  }

  const [approveRequestEmail, { isSuccess, isLoading }] = useApproveRequestEmailMutation()

  if (isSuccess) {
    return (
      <SuccessModal
        open={open}
        handleClose={handleClose}
        title={t('login.approve_request_email.success')}
        text={t('login.approve_request_email.success_description')}
      />
    )
  }

  return (
    <MyModal width="w-[calc(100%_-_2rem)] max-w-[640px]" open={open} handleClose={handleClose}>
      <h2 className="text-xl font-bold text-center">{t('login.approve_request_email.title')}</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <Controller
          control={control}
          rules={{
            required: t('email'),
            pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: t('email') },
          }}
          name="email"
          render={({ field, fieldState }) => (
            <InputField
              {...field}
              className="w-full flex-1"
              label={t('email')}
              placeholder={t('email')}
              error={fieldState.error}
            />
          )}
        />
        <Button isLoading={isLoading} type="submit" className="w-full">
          {t('login.approve_request_email.approve_email')}
        </Button>
      </form>
    </MyModal>
  )
}
